// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"556e81c5","365":"556e81c5","599":"556e81c5","614":"556e81c5","636":"556e81c5","778":"556e81c5","859":"556e81c5"}[chunkId] + ".chunk.css";
};